import * as React from 'react';
import RootComponent, { Props } from '@websky/core/src/SeatMap/components/SeatMap/Seat/Seat';
import { SeatMapColorsContext } from '../SeatMap';

const Seat: React.FC<Props> = props => {
	const colorsContext = React.useContext(SeatMapColorsContext);

	let color = props.isAvailable ? colorsContext?.[props.segmentId]?.get(props.seat.price?.amount) : null;

	if (props.isCombinedWith) {
		color = null;
	}

	return <RootComponent {...props} backgroundColor={color} hideSeatName={true} />;
};

export default Seat;
